import { c as _c } from "react/compiler-runtime";
import BnefLogo from '@/components/Atoms/BnefLogo/BnefLogo';
import { breakpoints } from '@/styles/media';
import type { AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';
export const Logo = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StyledLogo><BnefLogo /></StyledLogo>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <LogoBlock {...props} href="/" title="BloombergNEF">{t0}</LogoBlock>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const LogoBlock = styled.a`
    flex: 1;
    display: flex;
    line-height: 0;
    color: var(--cds-color-text);
    :hover {
        color: var(--color-NavigationLink-highlight);
    }
    ${breakpoints.L`
        flex: none;
        margin-right: var(--size-grid-half);
    `};
`;
const StyledLogo = styled.span`
    display: inline-block;
    // the descending 'g' means it looks more centered if the top padding is 2px more than it would be normally
    margin-top: calc(((var(--size-masthead-innerHeight) - 20px) / 2) + 2px);
    width: 140px;
`;